import { makeRequestCreator } from './common.js'
import store from '@/store'

const CartAPI = {
  /**
   * 장바구니에 있는 목록을 요청한다..
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getProductListOfCart: (successCallback = ()=>{}, errorCallback = ()=>{}) => {
    // 로그인 체크
    makeRequestCreator(
      'getProductListOfCart',
      {
        method: 'get',
        url: `/cart/list/${store.getters['main/shopSeq']}`,
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 장바구니에 제품을 추가한다.
   * @param {Object} obj - 제품 object
   * @param {Number} obj.productId - 제품 id
   * @param {Number} obj.purchaseCount - 구매 갯수
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  addProductOfCart: ({ productId, purchaseCount }, successCallback = ()=>{}, errorCallback = ()=>{}) => {

    makeRequestCreator(
      'addProductOfCart',
      {
        method: 'post',
        url: `/cart/add/${store.getters['main/shopSeq']}`,
        data: {
          addCartList: [{
            productId: productId.toString(),
            purchaseCount
          }]
        }
      },
      successCallback,
      errorCallback
    )
  },
   /**
   * 장바구니에 있는 제품의 갯수를 1개 증가시킨다
   * @param {Object} productId - 제품 id
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  increaseProductOfCart:({ productId }, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'increaseProductOfCart',
      {
        method: 'post',
        url: `/cart/purchasecount/add/${store.getters['main/shopSeq']}`,
        data: {
          productId
        }
      },
      successCallback,
      errorCallback
    )
  },
   /**
   * 장바구니에 있는 제품의 갯수를 1개 감소시킨다.
   * @param {Object} productId - 제품 id
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  decreaseProductOfCart: ({ productId, }, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'decreaseProductOfCart',
      {
        method: 'post',
        url: `/cart/purchasecount/sub/${store.getters['main/shopSeq']}`,
        data: {
          productId
        }
      },
      successCallback,
      errorCallback
    )


  },
  /**
   * 장바구니에 있는 제품을 제거한다.
   * @param {Array} productIds - 삭제할 제품 ID를 가진 배열
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  removeProductOfCart: (productIds, successCallback = ()=>{}, errorCallback = ()=>{}) => {
     makeRequestCreator(
      'removeProductOfCart',
      {
        method: 'post',
        url: `/cart/delete/${store.getters['main/shopSeq']}`,
        data: {
          productIds
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 장바구니에 있는 제품을 모두 제거한다.
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  removeAllProductOfCart: (successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'removeAllProductOfCart',
      {
        method: 'post',
        url: `/cart/deleteall/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  }

}

export default CartAPI
